import type { DynamicOptionsLoadingProps } from 'next/dynamic';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Button } from 'shared/components/button';
import { Loader } from 'shared/components/loader';
import { Text } from 'shared/components/text';

export function InsuranceModalLoading({ error, retry }: DynamicOptionsLoadingProps) {
  const { t } = useTranslation('common');

  return (
    <View
      className="flex-1 items-center justify-center gap-3 p-6"
      testID="insurance-content-loading"
    >
      {error ? (
        <>
          <Text accessibilityRole="alert">{t('notify_error_description')}</Text>
          {retry && <Button text={t('retry')} color="brown" onPress={retry} />}
        </>
      ) : (
        <Loader />
      )}
    </View>
  );
}
